import { render, staticRenderFns } from "./helpCenter.vue?vue&type=template&id=39197314&scoped=true&"
import script from "./helpCenter.vue?vue&type=script&lang=ts&"
export * from "./helpCenter.vue?vue&type=script&lang=ts&"
import style0 from "./helpCenter.vue?vue&type=style&index=0&id=39197314&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39197314",
  null
  
)

export default component.exports